// import React, { useEffect, useState } from 'react'
// import Layout from '../components/layout'
// import axios from 'axios';
// import { apiurl } from '../config/config';
// import { getCookie } from '../config/webStorage';
// import { MdOutlineCancel } from "react-icons/md";
// import { toast } from 'react-toastify';
// import { MdContentCopy } from "react-icons/md";

// function WhatsappAccounts() {
//     const token = getCookie("sctoken");

//     // Mock BackHeader component
//     const BackHeader = ({ title, rightSide }) => (
//         <div className="flex justify-between items-center mb-4 p-4 bg-white shadow-sm">
//             <h1 className="text-xl font-bold">{title}</h1>
//             <div>{rightSide}</div>
//         </div>
//     );

//     // Mock Pagination component
//     const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
//         const totalPages = Math.ceil(totalItems / itemsPerPage);
//         return (
//             <div className="flex justify-center mt-4">
//                 {Array.from({ length: totalPages }, (_, i) => (
//                     <button
//                         key={i}
//                         onClick={() => onPageChange(i + 1)}
//                         className={`mx-1 px-3 py-1 rounded ${currentPage === i + 1 ? 'bg-primary text-white' : 'bg-gray-200'}`}
//                     >
//                         {i + 1}
//                     </button>
//                 ))}
//             </div>
//         );
//     };

//     // MockCheckbox component
//     const Checkbox = ({ checked, onChange }) => (
//         <input type="checkbox" checked={checked} onChange={onChange} className="h-4 w-4" />
//     );

//     const [accounts, setAccounts] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchInput, setSearchInput] = useState("");
//     const [statusFilter, setStatusFilter] = useState("All");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(50);
//     const [showPopup, setShowPopup] = useState(false);
//     const [showDetailsPopup, setShowDetailsPopup] = useState(false);
//     const [selectedAccount, setSelectedAccount] = useState(null);
//     const [newAccount, setNewAccount] = useState({
//         name: "",
//         WHATSAPP_BUSINESS_ACCOUNT_ID: "",
//         PHONE_NUMBER: "",
//         PHONE_NUMBER_ID: "",
//         client_webhook_url: "",
//         status: "active",
//         // meta_api_access_token: "",
//         // flow_enable: true,
//         // tenant_id: "",
//         // configuration_id: ""
//     });

//     // Fetch all accounts
//     const fetchAccounts = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const response = await axios.get(`${apiurl}/api/whatsapp/account/get`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             setAccounts(response.data.WhatsappAccount_details || []);
//         } catch (err) {
//             setError("Failed to fetch WhatsApp accounts.");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch single account and show popup
//     const fetchSingleAccount = async (id) => {
//         try {
//             const response = await axios.get(`${apiurl}/api/whatsapp/account/get/${id}`, {
//                 headers: { Authorization: `Bearer ${token}` },
//             });
//             setSelectedAccount(response.data.WhatsappAccount_details[0]);
//             setShowDetailsPopup(true);
//         } catch (err) {
//             setError("Error fetching account details");
//             console.error("Error fetching single account:", err);
//         }
//     };

//     // Create new account
//     const createAccount = async () => {
//         try {
//             const response = await axios.post(
//                 `${apiurl}/api/whatsapp/account/create`,
//                 newAccount,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );
//             setAccounts([...accounts, response.data]);
//             setShowPopup(false);
//             setNewAccount({
//                 name: "",
//                 WHATSAPP_BUSINESS_ACCOUNT_ID: "",
//                 PHONE_NUMBER: "",
//                 PHONE_NUMBER_ID: "",
//                 client_webhook_url: "",
//                 status: "active",
//                 meta_api_access_token: "",
//                 flow_enable: true,
//                 tenant_id: "20001",
//                 configuration_id: "10001"
//             });
//         } catch (err) {
//             setError("Failed to create WhatsApp account.");
//             console.error(err);
//         }
//     };

//     useEffect(() => {
//         fetchAccounts();
//     }, [currentPage, itemsPerPage]);

//     // Filter and search logic
//     const filteredAccounts = accounts.filter((account) => {
//         const matchesSearch = account.name.toLowerCase().includes(searchInput.toLowerCase()) ||
//             account.PHONE_NUMBER.toLowerCase().includes(searchInput.toLowerCase());
//         const matchesStatus = statusFilter === "All" || account.status.toLowerCase() === statusFilter.toLowerCase();
//         return matchesSearch && matchesStatus;
//     });

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentAccounts = filteredAccounts.slice(indexOfFirstItem, indexOfLastItem);

//     const copyToClipboard = (text) => {
//         navigator.clipboard.writeText(text);
//         toast.success("Copied to clipboard!"); // Shows toast message
//     };
//     const truncateText = (text, start = 10, end = 10) => {
//         if (text.length > start + end) {
//             return `${text.slice(0, start)}...${text.slice(-end)}`;
//         }
//         return text;
//     };

//     return (
//         <Layout>
//             <div className="border bg-white h-full w-full px-2 py-2">
//                 <div className="relative flex flex-col gap-2 w-full overflow-hidden rounded-sm sm:rounded-xl px-2 h-full p-2">
//                     <BackHeader
//                         title={
//                             <span className="flex flex-col md:flex-row items-center gap-2">
//                                 WhatsApp Accounts
//                                 <span className="hidden lg:flex"> - {accounts.length}</span>
//                                 {/* <select
//                                     value={itemsPerPage}
//                                     className="text-xs rounded-sm text-black border px-2 py-1 mx-2"
//                                     onChange={(e) => setItemsPerPage(e.target.value)}
//                                 >
//                                     <option value="50">50</option>
//                                     <option value="100">100</option>
//                                     <option value="250">250</option>
//                                     <option value="500">500</option>
//                                     <option value="1000">1000</option>
//                                 </select> */}
//                                 <div className="hidden lg:flex gap-2 flex-row items-center">
//                                     <label className="text-xs">Status:</label>
//                                     <select
//                                         value={statusFilter}
//                                         onChange={(e) => setStatusFilter(e.target.value)}
//                                         className="border px-2 py-1 rounded-sm text-xs outline-none"
//                                     >
//                                         <option value="All">All</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                 </div>
//                             </span>
//                         }
//                         rightSide={
//                             <div className="flex gap-2 items-center">
//                                 {/* <input
//                                     type="text"
//                                     value={searchInput}
//                                     onChange={(e) => setSearchInput(e.target.value)}
//                                     placeholder="Search Accounts..."
//                                     className="border px-2 py-1 rounded-sm text-sm outline-none"
//                                 /> */}
//                                 <button
//                                     onClick={() => setShowPopup(true)}
//                                     className="bg-primary hover:bg-secondary hover:text-primary text-primary border border-secondary font-medium px-3 py-1 rounded-sm text-sm flex items-center gap-1"
//                                 >
//                                     <span className="hidden md:block">Create</span>
//                                     <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
//                                     </svg>
//                                 </button>
//                             </div>
//                         }
//                     />
//                     {loading ? (
//                         <div className="text-center py-4">Loading...</div>
//                     ) : error ? (
//                         <div className="text-center py-4 text-red-500">{error}</div>
//                     ) : filteredAccounts.length === 0 ? (
//                         <div className="text-center py-4">No WhatsApp accounts found.</div>
//                     ) : (
//                         <div className="relative overflow-y-auto h-full sm:rounded-sm">
//                             <table className="w-full text-sm text-left text-gray-500">
//                                 <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
//                                     <tr>
//                                         {/* <th scope="col" className="p-4">
//                                             <Checkbox />
//                                         </th> */}
//                                         <th scope="col" className="px-6 py-3">Name</th>
//                                         <th scope="col" className="px-6 py-3">Phone Number</th>
//                                         <th scope="col" className="px-6 py-3">Business Account ID</th>
//                                         <th scope="col" className="px-6 py-3">Phone Number ID</th>
//                                         <th scope="col" className="px-6 py-3">Status</th>
//                                         <th scope="col" className="px-6 py-3">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentAccounts.map((account, index) => (
//                                         <tr
//                                             key={account._id}
//                                             className={`${index % 2 === 0 ? "odd:bg-white" : "even:bg-gray-50"} border-b`}
//                                         >
//                                             {/* <td className="p-4">
//                                                 <Checkbox />
//                                             </td> */}
//                                             <td className="px-6 py-4">{account.name}</td>
//                                             <td className="px-6 py-4">{account.PHONE_NUMBER}</td>
//                                             <td className="px-6 py-4">{account.WHATSAPP_BUSINESS_ACCOUNT_ID}</td>
//                                             <td className="px-6 py-4">{account.PHONE_NUMBER_ID}</td>
//                                             <td className={`px-6 py-4 font-medium ${account.status === "active" ? "text-green-500" : "text-red-500"}`}>
//                                                 {account.status}
//                                             </td>
//                                             <td className="px-6 py-4">
//                                                 <button
//                                                     onClick={() => fetchSingleAccount(account.id)}
//                                                     className="text-blue-500 hover:underline"
//                                                 >
//                                                     View
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}
//                     <Pagination
//                         currentPage={currentPage}
//                         totalItems={filteredAccounts.length}
//                         itemsPerPage={itemsPerPage}
//                         onPageChange={setCurrentPage}
//                     />
//                 </div>

//                 {/* Popup for creating new account */}
//                 {showPopup && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
//                         <div className="bg-white relative p-6 rounded-lg w-full max-w-xl max-h-[70vh] overflow-y-scroll hide-scrollbar">
//                             <div className='absolute cursor-pointer top-4 right-4 text-xl text-primary' onClick={() => setShowPopup(false)}>
//                                 <MdOutlineCancel />
//                             </div>
//                             <h2 className="text-lg font-bold text-primary my-4 ">Create WhatsApp Account</h2>
//                             <div className="space-y-4">
//                                 {/* Name Input */}
//                                 <div className="relative">
//                                     {newAccount.name && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             Name
//                                         </label>
//                                     )}
//                                     <input
//                                         type="text"
//                                         placeholder="Name"
//                                         value={newAccount.name}
//                                         onChange={(e) => setNewAccount({ ...newAccount, name: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     />
//                                 </div>

//                                 {/* WhatsApp Business Account ID */}
//                                 <div className="relative">
//                                     {newAccount.WHATSAPP_BUSINESS_ACCOUNT_ID && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             WhatsApp Business Account ID
//                                         </label>
//                                     )}
//                                     <input
//                                         type="text"
//                                         placeholder="WhatsApp Business Account ID"
//                                         value={newAccount.WHATSAPP_BUSINESS_ACCOUNT_ID}
//                                         onChange={(e) => setNewAccount({ ...newAccount, WHATSAPP_BUSINESS_ACCOUNT_ID: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     />
//                                 </div>

//                                 {/* Phone Number */}
//                                 <div className="relative">
//                                     {newAccount.PHONE_NUMBER && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             Phone Number
//                                         </label>
//                                     )}
//                                     <input
//                                         type="text"
//                                         placeholder="Phone Number"
//                                         value={newAccount.PHONE_NUMBER}
//                                         onChange={(e) => setNewAccount({ ...newAccount, PHONE_NUMBER: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     />
//                                 </div>

//                                 {/* Phone Number ID */}
//                                 <div className="relative">
//                                     {newAccount.PHONE_NUMBER_ID && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             Phone Number ID
//                                         </label>
//                                     )}
//                                     <input
//                                         type="text"
//                                         placeholder="Phone Number ID"
//                                         value={newAccount.PHONE_NUMBER_ID}
//                                         onChange={(e) => setNewAccount({ ...newAccount, PHONE_NUMBER_ID: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     />
//                                 </div>

//                                 {/* Client Webhook URL */}
//                                 <div className="relative">
//                                     {newAccount.client_webhook_url && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             Client Webhook URL
//                                         </label>
//                                     )}
//                                     <input
//                                         type="text"
//                                         placeholder="Client Webhook URL"
//                                         value={newAccount.client_webhook_url}
//                                         onChange={(e) => setNewAccount({ ...newAccount, client_webhook_url: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     />
//                                 </div>

//                                 {/* Status Select */}
//                                 <div className="relative">
//                                     {newAccount.status && (
//                                         <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
//                                             Status
//                                         </label>
//                                     )}
//                                     <select
//                                         value={newAccount.status}
//                                         onChange={(e) => setNewAccount({ ...newAccount, status: e.target.value })}
//                                         className="w-full border px-2 py-2 rounded-sm"
//                                     >
//                                         <option value="">Select Status</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="mt-6 flex justify-end gap-2">
//                                 <button
//                                     onClick={() => setShowPopup(false)}
//                                     className="px-4 py-2 bg-gray-200 rounded-sm"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={createAccount}
//                                     className="px-4 py-2 border border-secondary bg-primary hover:bg-secondary hover:text-primary font-medium rounded-sm"
//                                 >
//                                     Create
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Popup for viewing account details */}
//                 {showDetailsPopup && selectedAccount && (
//                     <div className={`fixed inset-0 bg-gray-900 bg-opacity-60 flex items-center justify-center p-4 z-50 ${showDetailsPopup ? 'block' : 'hidden'}`}>
//                         <div className="bg-white relative rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto mx-4 sm:mx-0">
//                             {/* Close Button */}
//                             <button
//                                 className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 transition-colors p-1 z-20"
//                                 onClick={() => setShowDetailsPopup(false)}
//                                 aria-label="Close popup"
//                             >
//                                 <MdOutlineCancel size={24} />
//                             </button>

//                             {/* Header */}
//                             <div className="p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
//                                 <h2 className="text-2xl font-bold text-gray-900">Account Details</h2>
//                                 <p className="text-sm text-gray-500 mt-1">View and manage your account information</p>
//                             </div>

//                             {/* Content */}
//                             <div className="p-6 space-y-5">
//                                 {/* Basic Fields */}
//                                 {[
//                                     { label: "Name", value: selectedAccount.name },
//                                     { label: "Phone Number", value: selectedAccount.PHONE_NUMBER },
//                                     { label: "Business Account ID", value: selectedAccount.WHATSAPP_BUSINESS_ACCOUNT_ID },
//                                     { label: "Phone Number ID", value: selectedAccount.PHONE_NUMBER_ID },
//                                     { label: "Status", value: selectedAccount.status, isBadge: true },
//                                     { label: "API Enable", value: selectedAccount.api_enable ? "Yes" : "No" },
//                                     { label: "Flow Enable", value: selectedAccount.flow_enable ? "Yes" : "No" }
//                                 ].map((item, index) => (
//                                     <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center">
//                                         <span className="font-medium text-gray-700 text-sm sm:text-right">{item.label}:</span>
//                                         <span className={`sm:col-span-2 w-fit text-sm ${item.isBadge
//                                                 ? `inline-flex items-center px-3 py-1 rounded-full font-medium ${item.value === "active"
//                                                     ? "bg-green-100 text-green-800"
//                                                     : "bg-red-100 text-red-800"
//                                                 }`
//                                                 : "text-gray-600"
//                                             }`}>
//                                             {item.value}
//                                         </span>
//                                     </div>
//                                 ))}

//                                 {/* URLs with Copy */}
//                                 {[
//                                     { label: "Callback URL", value: selectedAccount.Callback_URL },
//                                     { label: "Client Webhook URL", value: selectedAccount.client_webhook_url }
//                                 ].map((item, index) => (
//                                     <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center">
//                                         <span className="font-medium text-gray-700 text-sm sm:text-right">{item.label}:</span>
//                                         <div className="sm:col-span-2 flex items-center gap-2 flex-wrap">
//                                             <a
//                                                 href={item.value}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 className="text-[blue-600] hover:text-blue-800 transition-colors break-all text-sm"
//                                             >
//                                                 {truncateText(item.value, 40)}
//                                             </a>
//                                             <button
//                                                 className="text-gray-500 hover:text-gray-700 transition-colors p-1"
//                                                 onClick={() => copyToClipboard(item.value)}
//                                                 aria-label="Copy URL"
//                                             >
//                                                 <MdContentCopy size={16} />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}

//                                 {/* Tokens */}
//                                 {[
//                                     { label: "Meta API Access Token", value: selectedAccount.meta_api_access_token },
//                                     { label: "Inficonnect API Key", value: selectedAccount.inficonnect_api_key }
//                                 ].map((item, index) => (
//                                     <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center">
//                                         <span className="font-medium text-gray-700 text-sm sm:text-right">{item.label}:</span>
//                                         <div className="sm:col-span-2 flex items-center gap-2 bg-gray-50 p-3 rounded-lg group">
//                                             <span
//                                                 className="text-sm text-gray-600 break-all flex-1 group-hover:text-gray-800 transition-colors cursor-default"
//                                                 title={item.value}
//                                             >
//                                                 {truncateText(item.value, 30)}
//                                             </span>
//                                             <button
//                                                 className="text-gray-500 hover:text-gray-700 transition-colors p-1"
//                                                 onClick={() => copyToClipboard(item.value)}
//                                                 aria-label="Copy token"
//                                             >
//                                                 <MdContentCopy size={16} />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>

//                 )}
//             </div>
//         </Layout>
//     )
// }

// export default WhatsappAccounts

import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { getCookie } from "../config/webStorage";
import { MdOutlineCancel } from "react-icons/md";
import { toast } from "react-toastify";
import { MdContentCopy } from "react-icons/md";

function WhatsappAccounts() {
  const token = getCookie("sctoken");

  // Mock BackHeader component
  const BackHeader = ({ title, rightSide }) => (
    <div className="flex justify-between items-center mb-4 p-4 bg-white shadow-sm">
      <h1 className="text-xl font-bold text-primary">{title}</h1>
      <div>{rightSide}</div>
    </div>
  );

  // Mock Pagination component
  const Pagination = ({
    currentPage,
    totalItems,
    itemsPerPage,
    onPageChange,
  }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    return (
      <div className="flex justify-center mt-4">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => onPageChange(i + 1)}
            className={`mx-1 px-3 py-1 rounded ${currentPage === i + 1 ? "bg-primary text-white" : "bg-light-secondary text-primary hover:bg-accent"}`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    );
  };

  // MockCheckbox component
  // const Checkbox = ({ checked, onChange }) => (
  //     <input type="checkbox" checked={checked} onChange={onChange} className="h-4 w-4 text-light-primary" />
  // );

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  // const [itemsPerPage, setItemsPerPage] = useState(50);
  const [itemsPerPage] = useState(50);
  const [searchInput, setSearchInput] = useState("");
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [newAccount, setNewAccount] = useState({
    name: "",
    WHATSAPP_BUSINESS_ACCOUNT_ID: "",
    PHONE_NUMBER: "",
    PHONE_NUMBER_ID: "",
    client_webhook_url: "",
    status: "active",
  });

  // Fetch all accounts
  // const fetchAccounts = async () => {
  //     setLoading(true);
  //     setError(null);
  //     try {
  //         const response = await axios.get(`${apiurl}/api/whatsapp/account/get`, {
  //             headers: { Authorization: `Bearer ${token}` },
  //         });
  //         setAccounts(response.data.WhatsappAccount_details || []);
  //     } catch (err) {
  //         setError("Failed to fetch WhatsApp accounts.");
  //         console.error(err);
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const fetchAccounts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiurl}/api/whatsapp/account/get`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAccounts(response.data.WhatsappAccount_details || []);
    } catch (err) {
      setError("Failed to fetch WhatsApp accounts.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // Fetch single account and show popup
  const fetchSingleAccount = async (id) => {
    try {
      const response = await axios.get(
        `${apiurl}/api/whatsapp/account/get/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setSelectedAccount(response.data.WhatsappAccount_details[0]);
      setShowDetailsPopup(true);
    } catch (err) {
      setError("Error fetching account details");
      console.error("Error fetching single account:", err);
    }
  };

  // Create new account
  const createAccount = async () => {
    try {
      const response = await axios.post(
        `${apiurl}/api/whatsapp/account/create`,
        newAccount,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setAccounts([...accounts, response.data]);
      setShowPopup(false);
      setNewAccount({
        name: "",
        WHATSAPP_BUSINESS_ACCOUNT_ID: "",
        PHONE_NUMBER: "",
        PHONE_NUMBER_ID: "",
        client_webhook_url: "",
        status: "active",
      });
    } catch (err) {
      setError("Failed to create WhatsApp account.");
      console.error(err);
    }
  };

  // useEffect(() => {
  //     fetchAccounts();
  // }, [currentPage, itemsPerPage]);
  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts, currentPage, itemsPerPage]);

  // Filter and search logic
  const filteredAccounts = accounts.filter((account) => {
    const matchesSearch =
      account.name.toLowerCase().includes(searchInput.toLowerCase()) ||
      account.PHONE_NUMBER.toLowerCase().includes(searchInput.toLowerCase());
    const matchesStatus =
      statusFilter === "All" ||
      account.status.toLowerCase() === statusFilter.toLowerCase();
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAccounts = filteredAccounts.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  // const copyToClipboard = (text) => {
  //     navigator.clipboard.writeText(text);
  //     toast.success("Copied to clipboard!");
  // };
  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => toast.success("Copied to clipboard!"))
        .catch((err) => toast.error("Failed to copy: " + err));
    } else {
      toast.error("Clipboard not supported in this browser or context.");
    }
  };

  const truncateText = (text, start = 10, end = 10) => {
    if (text.length > start + end) {
      return `${text.slice(0, start)}...${text.slice(-end)}`;
    }
    return text;
  };

  return (
    <Layout>
      <div className="border bg-light-secondary h-full w-full px-2 py-2">
        <div className="relative flex flex-col gap-2 w-full overflow-hidden rounded-sm sm:rounded-xl px-2 h-full p-2">
          <BackHeader
            title={
              <span className="flex flex-col md:flex-row items-center gap-2">
                WhatsApp Accounts
                <span className="hidden lg:flex"> - {accounts.length}</span>
                <div className="hidden lg:flex gap-2 flex-row items-center">
                  <label className="text-xs text-primary">Status:</label>
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="border border-primary/50 bg-white px-2 py-1 rounded-sm text-xs outline-none text-primary"
                  >
                    <option value="All">All</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </span>
            }
            rightSide={
              <div className="flex gap-2 items-center">
                <input
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Search Accounts..."
                  className="border px-2 py-1 rounded-sm text-sm outline-none"
                />
                <button
                  onClick={() => setShowPopup(true)}
                  className="bg-primary hover:bg-light-primary text-white font-medium px-3 py-1 rounded-sm text-sm flex items-center gap-1"
                >
                  <span className="hidden md:block">Create</span>
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </button>
              </div>
            }
          />
          {loading ? (
            <div className="text-center py-4 text-primary">Loading...</div>
          ) : error ? (
            <div className="text-center py-4 text-error">{error}</div>
          ) : filteredAccounts.length === 0 ? (
            <div className="text-center py-4 text-primary">
              No WhatsApp accounts found.
            </div>
          ) : (
            <div className="relative overflow-y-auto h-full sm:rounded-sm">
              <table className="w-full text-sm text-left text-primary">
                <thead className="text-xs text-primary uppercase bg-accent sticky top-0">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Phone Number
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Business Account ID
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Phone Number ID
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Status
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentAccounts.map((account, index) => (
                    <tr
                      key={account._id}
                      className={`${index % 2 === 0 ? "odd:bg-white" : "even:bg-light-secondary"} border-b border-primary/50`}
                    >
                      <td className="px-6 py-4">{account.name}</td>
                      <td className="px-6 py-4">{account.PHONE_NUMBER}</td>
                      <td className="px-6 py-4">
                        {account.WHATSAPP_BUSINESS_ACCOUNT_ID}
                      </td>
                      <td className="px-6 py-4">{account.PHONE_NUMBER_ID}</td>
                      <td
                        className={`px-6 py-4 font-medium ${account.status === "active" ? "text-success" : "text-error"}`}
                      >
                        {account.status}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => fetchSingleAccount(account.id)}
                          className="text-light-primary hover:underline"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Pagination
            currentPage={currentPage}
            totalItems={filteredAccounts.length}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
          />
        </div>

        {/* Popup for creating new account */}
        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white relative p-6 rounded-lg w-full max-w-xl max-h-[70vh] overflow-y-scroll hide-scrollbar m-6">
              <div
                className="absolute cursor-pointer top-4 right-4 text-xl text-primary"
                onClick={() => setShowPopup(false)}
              >
                <MdOutlineCancel />
              </div>
              <h2 className="text-lg font-bold text-primary my-4">
                Create WhatsApp Account
              </h2>
              <div className="space-y-4">
                {/* Name Input */}
                <div className="relative">
                  {newAccount.name && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      Name
                    </label>
                  )}
                  <input
                    type="text"
                    placeholder="Name"
                    value={newAccount.name}
                    onChange={(e) =>
                      setNewAccount({ ...newAccount, name: e.target.value })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  />
                </div>

                {/* WhatsApp Business Account ID */}
                <div className="relative">
                  {newAccount.WHATSAPP_BUSINESS_ACCOUNT_ID && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      WhatsApp Business Account ID
                    </label>
                  )}
                  <input
                    type="text"
                    placeholder="WhatsApp Business Account ID"
                    value={newAccount.WHATSAPP_BUSINESS_ACCOUNT_ID}
                    onChange={(e) =>
                      setNewAccount({
                        ...newAccount,
                        WHATSAPP_BUSINESS_ACCOUNT_ID: e.target.value,
                      })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  />
                </div>

                {/* Phone Number */}
                <div className="relative">
                  {newAccount.PHONE_NUMBER && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      Phone Number
                    </label>
                  )}
                  <input
                    type="text"
                    placeholder="Phone Number"
                    value={newAccount.PHONE_NUMBER}
                    onChange={(e) =>
                      setNewAccount({
                        ...newAccount,
                        PHONE_NUMBER: e.target.value,
                      })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  />
                </div>

                {/* Phone Number ID */}
                <div className="relative">
                  {newAccount.PHONE_NUMBER_ID && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      Phone Number ID
                    </label>
                  )}
                  <input
                    type="text"
                    placeholder="Phone Number ID"
                    value={newAccount.PHONE_NUMBER_ID}
                    onChange={(e) =>
                      setNewAccount({
                        ...newAccount,
                        PHONE_NUMBER_ID: e.target.value,
                      })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  />
                </div>

                {/* Client Webhook URL */}
                <div className="relative">
                  {newAccount.client_webhook_url && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      Client Webhook URL
                    </label>
                  )}
                  <input
                    type="text"
                    placeholder="Client Webhook URL"
                    value={newAccount.client_webhook_url}
                    onChange={(e) =>
                      setNewAccount({
                        ...newAccount,
                        client_webhook_url: e.target.value,
                      })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  />
                </div>

                {/* Status Select */}
                <div className="relative">
                  {newAccount.status && (
                    <label className="absolute -top-3 left-2 text-sm text-primary bg-white px-1">
                      Status
                    </label>
                  )}
                  <select
                    value={newAccount.status}
                    onChange={(e) =>
                      setNewAccount({ ...newAccount, status: e.target.value })
                    }
                    className="w-full border border-primary/50 px-2 py-2 rounded-sm text-primary"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>

              <div className="mt-6 flex justify-end gap-2">
                <button
                  onClick={() => setShowPopup(false)}
                  className="px-4 py-2 bg-light-secondary text-primary rounded-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={createAccount}
                  className="px-4 py-2 bg-primary hover:bg-light-primary text-white font-medium rounded-sm"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Popup for viewing account details */}
        {showDetailsPopup && selectedAccount && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50 ${showDetailsPopup ? "block" : "hidden"}`}
          >
            <div className="bg-white relative rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto mx-4 sm:mx-0">
              {/* Close Button */}
              <button
                className="absolute right-4 top-4 text-primary hover:text-primary transition-colors p-1 z-20"
                onClick={() => setShowDetailsPopup(false)}
                aria-label="Close popup"
              >
                <MdOutlineCancel size={24} />
              </button>

              {/* Header */}
              <div className="p-6 border-b border-primary/50 sticky top-0 bg-white z-10">
                <h2 className="text-2xl font-bold text-primary">
                  Account Details
                </h2>
                <p className="text-sm text-primary mt-1">
                  View and manage your account information
                </p>
              </div>

              {/* Content */}
              <div className="p-6 space-y-5">
                {/* Basic Fields */}
                {[
                  { label: "Name", value: selectedAccount.name },
                  {
                    label: "Phone Number",
                    value: selectedAccount.PHONE_NUMBER,
                  },
                  {
                    label: "Business Account ID",
                    value: selectedAccount.WHATSAPP_BUSINESS_ACCOUNT_ID,
                  },
                  {
                    label: "Phone Number ID",
                    value: selectedAccount.PHONE_NUMBER_ID,
                  },
                  {
                    label: "Status",
                    value: selectedAccount.status,
                    isBadge: true,
                  },
                  {
                    label: "API Enable",
                    value: selectedAccount.api_enable ? "Yes" : "No",
                  },
                  {
                    label: "Flow Enable",
                    value: selectedAccount.flow_enable ? "Yes" : "No",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center"
                  >
                    <span className="font-medium text-primary text-sm sm:text-right">
                      {item.label}:
                    </span>
                    <span
                      className={`sm:col-span-2 w-fit text-sm ${
                        item.isBadge
                          ? `inline-flex items-center px-3 py-1 rounded-full font-medium ${
                              item.value === "active"
                                ? "bg-success/10 text-success"
                                : "bg-error/10 text-error"
                            }`
                          : "text-primary"
                      }`}
                    >
                      {item.value}
                    </span>
                  </div>
                ))}

                {/* URLs with Copy */}
                {[
                  {
                    label: "Callback URL",
                    value: selectedAccount.Callback_URL,
                  },
                  {
                    label: "Client Webhook URL",
                    value: selectedAccount.client_webhook_url,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center"
                  >
                    <span className="font-medium text-primary text-sm sm:text-right">
                      {item.label}:
                    </span>
                    <div className="sm:col-span-2 flex items-center gap-2 flex-wrap">
                      <a
                        href={item.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-light-primary hover:text-primary transition-colors break-all text-sm"
                      >
                        {truncateText(item.value, 40)}
                      </a>
                      <button
                        className="text-primary hover:text-primary transition-colors p-1"
                        onClick={() => copyToClipboard(item.value)}
                        aria-label="Copy URL"
                      >
                        <MdContentCopy size={16} />
                      </button>
                    </div>
                  </div>
                ))}

                {/* Tokens */}
                {[
                  {
                    label: "Meta API Access Token",
                    value: selectedAccount.meta_api_access_token,
                  },
                  {
                    label: "Inficonnect API Key",
                    value: selectedAccount.inficonnect_api_key,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center"
                  >
                    <span className="font-medium text-primary text-sm sm:text-right">
                      {item.label}:
                    </span>
                    <div className="sm:col-span-2 flex items-center gap-2 bg-light-secondary p-3 rounded-lg group">
                      <span
                        className="text-sm text-primary break-all flex-1 group-hover:text-primary transition-colors cursor-default"
                        title={item.value}
                      >
                        {truncateText(item.value, 30)}
                      </span>
                      <button
                        className="text-primary hover:text-primary transition-colors p-1"
                        onClick={() => copyToClipboard(item.value)}
                        aria-label="Copy token"
                      >
                        <MdContentCopy size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default WhatsappAccounts;
